const ALLOWABLE_TEMPLATES = [
  'You have been logged in from another window', // 2eoiy5r2wfc7ydp7
  'The app has been updated.', // 3uc981gy3dlmv8am
  'Login expired or missing', // hm74ph2zqge6fcq4
] as const;

const TEMPLATE_CODES: Record<string, string> = {};

export function encodeBase64URL(message: string): string {
  const utf8 = new TextEncoder().encode(message);
  const base64 = btoa(String.fromCharCode(...utf8));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function encodeURLCodeAndTruncate(message: string): string {
  const encoded = encodeBase64URL(message); // or encodeBase64UrlSafe(message)
  return encoded.slice(0, 16); // shorten if desired
}

export function messageToCode(message: string): string | null {
  if (!ALLOWABLE_TEMPLATES.includes(message as any)) return null;

  if (!TEMPLATE_CODES[message]) {
    TEMPLATE_CODES[message] = encodeURLCodeAndTruncate(message);
  }

  return TEMPLATE_CODES[message];
}

export function codeToMessage(code: string): string {
  for (const msg of ALLOWABLE_TEMPLATES) {
    const genCode = messageToCode(msg);
    if (genCode === code) return msg;
  }
  return '';
}
